<template>
  <v-tab-item :key="tabKey">
    <v-layout row wrap>
      <v-flex xs12>
        <v-list class="pa-1">
          <v-list-tile
            avatar
            v-for="n in 7"
            :key="n"
            class="elevation-1"
            style="border-radius: 13px"
          >
            <v-list-tile-avatar>
              <div class="thirdQR"></div>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title> Expirado </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon color="primary">more_horiz</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-tab-item>
</template>

<script>
export default {
  props: {
    tabKey: {
      required: true,
      type: Number,
    },
  },
}
</script>

<style scoped>
.thirdQR {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../../assets/mobil/expired.png');
  -webkit-mask-size: 100% 100%;
  margin-right: 3px;
}
::v-deep .v-list__tile {
  height: auto;
}
</style>
